export default __webpack_public_path__ + "static/media/03_foggy.6ac35440.JPG";